import React from 'react';
import { FileText, Lightbulb, ShieldCheck, Wrench, Paperclip, Download } from 'lucide-react';
import { BACKEND_URL } from './promoCart';
import { trackPromo } from '../../lib/promoAttribution';

export const DOC_TYPES = {
  datasheet: ['Fiche technique', FileText],
  photometric: ['Photométrie', Lightbulb],
  certificate: ['Certificat', ShieldCheck],
  manual: ['Notice de montage', Wrench],
  other: ['Document', Paperclip],
};

export const OfferDocuments = ({ offer, skipFirstDatasheet }) => {
  const firstDs = skipFirstDatasheet ? (offer.documents || []).find((d) => d.doc_type === 'datasheet') : null;
  const docs = (offer.documents || []).filter((d) => d !== firstDs);
  if (!docs.length && !offer.cert_marks?.length) return null;
  return (
    <div className="pt-3 border-t border-white/[0.06] space-y-2" data-testid={`offer-documents-${offer.slug}`}>
      {offer.cert_marks?.length > 0 && (
        <div className="flex gap-2" data-testid={`offer-cert-marks-${offer.slug}`}>
          {offer.cert_marks.map((m) => (
            <span key={m} title={`Certificat ${m} disponible`} className="h-7 min-w-[36px] px-2 rounded-md border border-[#F2EFE8]/40 text-[#F2EFE8] text-[11px] font-bold tracking-wide flex items-center justify-center" data-testid={`offer-cert-${offer.slug}-${m}`}>{m}</span>
          ))}
        </div>
      )}
      <div className="flex flex-wrap gap-1.5">
        {docs.map((d) => {
          const [name, Icon] = DOC_TYPES[d.doc_type] || DOC_TYPES.other;
          return (
            <a key={d.id} href={`${BACKEND_URL}/api/promo-docs/${d.id}`} target="_blank" rel="noopener noreferrer" onClick={() => trackPromo('doc_download', { offer_slug: offer.slug, doc_id: d.id })}
              className="h-11 md:h-9 px-3 rounded-lg border border-white/10 bg-white/[0.03] text-xs text-zinc-300 hover:text-[#F2EFE8] hover:border-[#C9A84C]/50 transition-colors flex items-center gap-1.5"
              data-testid={`offer-doc-${offer.slug}-${d.id}`}>
              <Icon className="w-3.5 h-3.5 text-[#C9A84C]" /> {d.label || name}
              <span className="text-zinc-500 uppercase text-[10px]">{d.ext}</span>
              <Download className="w-3 h-3 text-zinc-500" />
            </a>
          );
        })}
      </div>
    </div>
  );
};
